<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 24 24">
    <path
      d="M13.0599 12.3599L19.7099 19.0099L18.9999 19.7199L12.3499 13.0699L5.70993 19.7099L4.99993 18.9999L11.6499 12.3499L4.99993 5.70993L5.70993 4.99993L12.3599 11.6499L18.9999 4.99993L19.7099 5.70993L13.0599 12.3599Z"
      :class="colorClass"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.9998 4.64624L20.0635 5.70993L13.4135 12.3599L20.0635 19.0099L18.9999 20.0735L12.3499 13.4235L5.70993 20.0635L4.64637 18.9999L11.2962 12.3501L4.64624 5.71006L5.70993 4.64637L12.3598 11.2962L18.9998 4.64624ZM19.0001 5.35361L12.3601 12.0036L5.70993 5.35348L5.35361 5.70979L12.0036 12.3498L5.35348 18.9999L5.70993 19.3564L12.3499 12.7164L18.9999 19.3664L19.3564 19.0099L12.7064 12.3599L19.3564 5.70993L19.0001 5.35361Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
